import React from 'react';
import PropTypes from 'prop-types';

const Skeleton = ({ 
    width = '100%', 
    height = '1em', 
    borderRadius = '4px', 
    className = '', 
    style = {}, 
    ...props 
}) => {
    const styles = {
        width,
        height,
        borderRadius,
        ...style,
    };

    return (
        <div
            className={`skeleton ${className || ''}`}
            style={styles}
            {...props}
        />
    );
};

Skeleton.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    borderRadius: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
};

export default Skeleton;

